import { render, staticRenderFns } from "./IconBackArrow.vue?vue&type=template&id=7f1c7057"
import script from "./IconBackArrow.vue?vue&type=script&lang=js"
export * from "./IconBackArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports